import request from '@/utils/request';

export function getVendorList() {
  return request({
    url: `/basic-backend/operation/manage/getVendorList`,
    method: "get",
  });
}

export function getSystemList() {
  return request({
    url: `/basic-backend/operation/manage/getSystemList`,
    method: "get",
  });
}

export function getOperationVenderList(data) {
  return request({
    url: `/basic-backend/operation/manage/vendor/list`,
    method: "post",
    data,
  });
}

export function addVendorLog(data) {
  const logCode = 'operation_work_log';
  return request({
    url: `/basic-backend/log/manage/record/add/${logCode}`,
    method: "post",
    data,
  });
}

export function getVendorLog(data) {
  return request({
    url: `/basic-backend/log/manage/record/list`,
    method: "post",
    data,
  });
}
